import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {
  static values = {
    businessQueueId: Number
  }

  connect() {
    this.subscription = consumer.subscriptions.create(
      {
        channel: "BusinessQueueChannel",
        business_queue_id: this.businessQueueIdValue
      },
      {
        connected: () => {
          console.debug("[QueueStatusController] Connected to BusinessQueueChannel for queue", this.businessQueueIdValue)
        },

        disconnected: () => {
          console.debug("[QueueStatusController] Disconnected from BusinessQueueChannel")
        },

        received: (data) => {
          console.debug("[QueueStatusController] Received update:", data)
          if (data.action === 'update' || data.action === 'queue_status_update') {
            this.refresh()
          }
        }
      }
    )
  }

  disconnect() {
    this.refreshController?.abort()

    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  async refresh() {
    this.refreshController?.abort()
    this.refreshController = new AbortController()

    try {
      const response = await fetch(location.href, {
        headers: { Accept: "text/html" },
        cache: "no-store",
        signal: this.refreshController.signal
      })
      if (!response.ok) return

      const page = new DOMParser().parseFromString(await response.text(), "text/html")
      const updatedStatus = page.querySelector('[data-controller~="queue-status"]')
      if (updatedStatus) this.element.innerHTML = updatedStatus.innerHTML
    } catch (error) {
      if (error.name !== "AbortError") {
        console.debug("[QueueStatusController] Refresh failed:", error)
      }
    }
  }
}
